import React from "react";

const FormField = ({
  label,
  hint,
  suffix,
  type = "number",
  name,
  value,
  onChange,
  placeholder,
  required = false,
  step = ".01",
  min = "0",
  pattern,
}) => {
  const baseInput =
    "block w-full rounded-lg border border-gray-200 p-2.5 text-gray-900 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent transition-all";
  const inputClass = suffix
    ? `${baseInput} text-left pr-12`
    : `${baseInput} text-center`;

  return (
    <div>
      <label className="block text-xs font-medium text-gray-500 mb-1.5">
        {label}
        {required && <span className="text-gray-400"> *</span>}
        {hint && (
          <span className="ml-1.5 text-gray-400 font-normal">· {hint}</span>
        )}
      </label>
      <div className="relative">
        <input
          type={type}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          step={type === "number" ? step : undefined}
          min={type === "number" ? min : undefined}
          pattern={pattern}
          className={inputClass}
        />
        {suffix && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs font-medium text-gray-400 pointer-events-none">
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
};

export default FormField;
